<script lang="ts">
	import { fly, fade } from 'svelte/transition';

	
	
	
	
	
	
	
	interface Props {
		/** Whether the drawer is hidden (closed). Bind to toggle visibility. */
		hidden?: boolean;
		/** Whether clicking the backdrop closes the drawer. */
		activateClickOutside?: boolean;
		/** Whether to show a semi-transparent overlay behind the drawer. */
		backdrop?: boolean;
		/** Which Svelte transition the drawer uses to enter and leave. */
		transitionType?: 'fly' | 'fade';
		/** Parameters passed to the Svelte transition (e.g. direction, duration). */
		transitionParams?: object;
		/** Which edge the drawer is anchored to. */
		placement?: 'left' | 'right' | 'top' | 'bottom';
		/** Tailwind width class for the drawer panel. */
		width?: string;
		/** Additional CSS classes applied to the drawer container element. */
		divClass?: string;
		/** HTML id attribute for the drawer element. */
		id?: string;
		class?: string;
		children?: import('svelte').Snippet;
		/** Callback fired when the user clicks outside the drawer (on the backdrop). */
		onclickoutside?: () => void;
	}

	let {
		hidden = $bindable(true),
		activateClickOutside = true,
		backdrop = true,
		transitionType = 'fly',
		transitionParams = { x: -250, duration: 200 },
		placement = 'left',
		width = 'w-80',
		divClass = '',
		id = 'drawer',
		class: className = '',
		children,
		onclickoutside
	}: Props = $props();

	/*
	 * Anchor with `inset-*` rather than a fixed `h-screen`/`w-screen`, so a
	 * margin on the drawer (see `#sidebar` in app.css, which insets it by 10px
	 * to float it) shrinks the box instead of pushing it off-screen.
	 */
	const placements = {
		left: 'inset-y-0 left-0',
		right: 'inset-y-0 right-0',
		top: 'inset-x-0 top-0',
		bottom: 'inset-x-0 bottom-0'
	};

	/** The transition the drawer enters and leaves with. */
	let drawerTransition = $derived(transitionType === 'fade' ? fade : fly);

	/** Closes the drawer and fires the onclickoutside callback when the backdrop is clicked. */
	function clickOutside() {
		if (activateClickOutside && !hidden) {
			hidden = true;
			onclickoutside?.();
		}
	}
</script>

{#if backdrop && !hidden}
	<!-- svelte-ignore a11y_no_static_element_interactions -->
	<div
		onclick={clickOutside}
		onkeypress={() => {}}
		class="fixed inset-0 z-30 bg-gray-900/50"
		transition:fade={{ duration: 200 }}
	></div>
{/if}

{#if !hidden}
	<div
		{id}
		class="fixed {placements[placement]} z-40 overflow-y-auto {width} {divClass} {className}"
		transition:drawerTransition={transitionParams}
	>
		{@render children?.()}
	</div>
{/if}
